const passionFruitPulpData = {
  hero_section: {
    title: "Premium Passion Fruit Pulp Collection",
    description: "100% Natural • No Preservatives • Exotic Tropical Flavor",
    src: "videos/passion-fruit-processing.webm",
  },
  description: {
    title: "Premium Passion Fruit Pulp Collection",
    main_description:
      "Discover our range of 100% natural passion fruit pulp, crafted from the finest passion fruits to preserve the intense tropical flavors and aromatic qualities.",
    segment_description:
      "Perfect for premium beverages, exotic desserts, and gourmet food applications.",
    variety_description:
      "Available in various grades and pack sizes to suit every commercial need.",
  },
  main_product: {
    title: "Premium Passion Fruit Pulp",
    description: "Our passion fruit pulp delivers intense tropical flavor with distinctive aroma. Rich in vitamins and antioxidants, it's perfect for premium beverages, exotic desserts, and gourmet applications.",
    image: "New-Images/Passion fruit.png",
    mainFeatures: [
      "Intense tropical flavor profile",
      "Rich aromatic qualities",
      "High in vitamins and antioxidants",
      "Perfect for premium applications",
      "Natural processing methods",
      "Consistent quality and freshness"
    ],
    nutrition: {
      servingSize: "100g",
      calories: "112",
      fat: "0g",
      carbs: "26g (Sugar: 26g, Added: 15g)",
      fiber: "0g",
      protein: "~1g",
      sodium: "5mg",
      potassium: "236mg",
      note: "Protein value on source looked incorrect; typical is around 1g."
    }
  },
  products: [
    {
      id: "1",
      name: "Premium Passion Fruit Pulp",
      image: "New-Images/Passion fruit.png",
      features: [
        "Intense tropical flavor",
        "Rich aromatic profile",
        "Premium quality",
        "Perfect for beverages"
      ],
      meta: {
        weight: "Customized pack sizes"
      }
    }
  ],

  text_section: {
    title: "Passion Fruit Pulp Excellence",
    description: "Our passion fruit pulp is processed from the finest handpicked passion fruits using advanced processing techniques. We maintain strict quality control to ensure consistent flavor, aroma, and nutritional value in every batch.",
  },
  
  feature_text_section: {
    title: "Perfect for Premium Applications",
    subline: "From exotic beverages to gourmet desserts – intense tropical flavor in every drop!",
    description:
      "Ideal for premium beverage manufacturers, gourmet restaurants, exotic dessert producers, and food service providers who demand exceptional quality and authentic tropical taste.",
  },
  
  feature_cards_info_card: [
    {
      id: 1,
      image: "beverage-applications.webp",
      title: "Premium Beverage Applications",
      description:
        "Perfect for exotic juices, premium smoothies, and tropical cocktail mixes with intense flavor and aroma.",
    },
    {
      id: 2,
      image: "dessert-applications.webp",
      title: "Gourmet Dessert Applications",
      description:
        "Ideal for premium desserts, exotic ice creams, and gourmet confectionery requiring authentic passion fruit taste.",
    },
    {
      id: 3,
      image: "food-service-applications.webp",
      title: "Premium Food Service",
      description:
        "Excellent for high-end restaurants, gourmet cafes, and premium catering services looking for exotic ingredients.",
    },
  ],
  
  overlay_card: [
    {
      id: 1,
      key: "Natural Processing",
      image: "natural-processing.webp",
      title: "Natural Processing",
      description:
        "No artificial preservatives, colors, or additives—just pure, natural passion fruit goodness",
    },
    {
      id: 2,
      key: "Quality Assurance",
      image: "quality-assurance.webp",
      title: "Quality Assurance",
      description:
        "Rigorous testing and quality control at every stage ensures premium standards",
    },
    {
      id: 3,
      key: "Consistent Supply",
      image: "consistent-supply.webp",
      title: "Consistent Supply",
      description:
        "Reliable production capacity and supply chain for your business needs",
    },
    {
      id: 4,
      key: "Exotic Excellence",
      image: "exotic-excellence.webp",
      title: "Exotic Excellence",
      description:
        "Specialized handling of exotic fruits to preserve unique flavors and characteristics",
    },
  ],
  
  why_choose_section: {
    title: "Why Choose Our Passion Fruit Pulp",
    description: "Discover the perfect blend of quality, intensity, and authentic exotic flavors that make our passion fruit pulp the preferred choice for premium food manufacturers worldwide.",
  },
};

export default passionFruitPulpData;
